import { InjectionToken } from '@angular/core';

/** Public reCAPTCHA v3 site key; provide per app via `environment.recaptchaSiteKey`. */
export const RECAPTCHA_SITE_KEY = new InjectionToken<string>('RECAPTCHA_SITE_KEY', {
  factory: () => '',
});
